import axios from "axios";
import Config from "../../../config/index";
import {
  CREATE_COMPLIANCE_FAILURE,
  CREATE_COMPLIANCE_REQUEST,
  CREATE_COMPLIANCE_SUCCESS,
  EDIT_COMPLIANCE_FAILURE,
  EDIT_COMPLIANCE_REQUEST,
  EDIT_COMPLIANCE_SUCCESS,
  GET_COMPLIANCE_FAILURE,
  GET_COMPLIANCE_REQUEST,
  GET_COMPLIANCE_SUCCESS,
  GET_DELETE_COMPLIANCE_FAILURE,
  GET_DELETE_COMPLIANCE_REQUEST,
  GET_DELETE_COMPLIANCE_SUCCESS,
  UPLOAD_COMPLIANCE_FAILURE,
  UPLOAD_COMPLIANCE_REQUEST,
  UPLOAD_COMPLIANCE_SUCCESS,
} from "./complianceTypes";

let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

const getComplianceRequest = () => {
  return {
    type: GET_COMPLIANCE_REQUEST,
  };
};

const getComplianceSuccess = (payload) => {
  return {
    type: GET_COMPLIANCE_SUCCESS,
    payload: payload,
  };
};

const getComplianceFailure = (error) => {
  return {
    type: GET_COMPLIANCE_FAILURE,
    payload: error,
  };
};
const getCompliance = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getComplianceRequest());

    let url;

    // If dppId is provided → call endpoint with dppId
    if (dppId) {
      url = `${baseUrl}/dpp/get_social_compliance_bydpp?dppId=${dppId}`;
    } else {
      // If dppId is NOT provided → call base endpoint
      url = `${baseUrl}/dpp/get_social_compliance`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getComplianceSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getComplianceFailure(err.message));
      });
  };
};


const deleteComplianceRequest = () => {
  return {
    type: GET_DELETE_COMPLIANCE_REQUEST,
  };
};

const deleteComplianceSuccess = (payload) => {
  return {
    type: GET_DELETE_COMPLIANCE_SUCCESS,
    payload: payload,
  };
};

const deleteComplianceFaliure = (error) => {
  return {
    type: GET_DELETE_COMPLIANCE_FAILURE,
    payload: error,
  };
};

const deleteCompliance = (complianceId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(deleteComplianceRequest());
    // let url = `${baseUrl}/dpp/product_passport/delete?dppId=${dppId}`;

    let url = `${baseUrl}/dpp/delete_social_compliance?complianceId=${complianceId}`;
    // let url = `${baseUrl}/mvtmap?id=${productId}`;
    // let url = `/mvtmap?id=334`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deleteComplianceSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteComplianceFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createComplianceRequest = () => {
  return {
    type: CREATE_COMPLIANCE_REQUEST,
  };
};

const createComplianceSuccess = (payload) => {
  return {
    type: CREATE_COMPLIANCE_SUCCESS,
    payload: payload,
  };
};

const createComplianceFailure = (error) => {
  return {
    type: CREATE_COMPLIANCE_FAILURE,
    payload: error,
  };
};

const createCompliance = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createComplianceRequest());
    let url = `${baseUrl}/dpp/create_social_compliance`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createComplianceSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createComplianceFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const editComplianceRequest = () => {
  return {
    type: EDIT_COMPLIANCE_REQUEST,
  };
};

const editComplianceSuccess = (payload) => {
  return {
    type: EDIT_COMPLIANCE_SUCCESS,
    payload: payload,
  };
};

const editComplianceFailure = (error) => {
  return {
    type: EDIT_COMPLIANCE_FAILURE,
    payload: error,
  };
};

const editCompliance = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editComplianceRequest());
    let url = `${baseUrl}/dpp/update_social_compliance`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(editComplianceSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editComplianceFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadForComplianceRequest = () => {
  return {
    type: UPLOAD_COMPLIANCE_REQUEST,
  };
};

const uploadForComplianceSuccess = (payload) => {
  return {
    type: UPLOAD_COMPLIANCE_SUCCESS,
    payload: payload,
  };
};

const uploadForComplianceFailure = (error) => {
  return {
    type: UPLOAD_COMPLIANCE_FAILURE,
    payload: error,
  };
};

const uploadForCompliance = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadForComplianceRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_Compliance/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadForComplianceSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadForComplianceFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};




export {
  getCompliance,
  deleteCompliance,
  createCompliance,
    editCompliance,
    uploadForCompliance
  //  getDocumentTypeWithPagination
  //  , createDocumentType
};
